<template>
	<v-row>
		<!-- <v-col cols="6" sm="4" md="3" v-for="opt in flavorOptions" :key="opt.value">
										<v-checkbox :label="opt.label" :value="opt.value" v-model="selectedTags" />
									</v-col> -->
		<v-col cols="12" class="my-0 py-0">
			<v-checkbox label="花香" :value="'flower'" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="果香" :value="'fruit'" v-model="selectedTags" dense hide-details="auto" />
			<v-checkbox label="莓果" :value="'berry'" v-model="selectedTags" dense hide-details="auto" />
			<v-checkbox label="果干" :value="'dried_fruit'" v-model="selectedTags" dense hide-details="auto" />
			<v-checkbox label="柑橘类水果" :value="'citrus'" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="尖酸" :value="'sharp'" v-model="selectedTags" dense hide-details="auto" />
			<v-checkbox label="发酵" :value="'fermented'" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="绿色/植物" :value="'green_plant'" v-model="selectedTags" hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="化学" :value="'chemical'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="陈腐/泥土" :value="'earthy'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="木质" :value="'woody'" v-model="selectedTags" hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="烘烤的" :value="'roasted'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="谷物" :value="'grain'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="烧焦的" :value="'burnt'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="烟草" :value="'tobacco'" v-model="selectedTags" hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="坚果" :value="'nut'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="可可" :value="'cocoa'" v-model="selectedTags" hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="香料" :value="'spice'" v-model="selectedTags" hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="香草/香草醛" :value="'vanilla'" v-model="selectedTags" hide-details="auto" />
			<v-checkbox label="黄糖" :value="'brown_sugar'" v-model="selectedTags" hide-details="auto" />
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: {
		tags: {
			type: Array,
			default: () => []
		}
	},
	emits: ['update:tags'],
	computed: {
		selectedTags: {
			get() {
				return this.tags || []
			},
			set(value) {
				this.$emit('update:tags', value)
			}
		}
	}
}
</script>
<style></style>
